import React, { useState, useEffect } from 'react';
import { HeadingText, Col, Row, Container, TextDisplay, TextInput, Button, Alert, PhoneInput, Dialog } from '@paypalcorp/pp-react';
import { get } from 'lodash';
import { validateEmail } from '../../common/domUtils';
import { parseMessages } from '../../utilityHelper';
import * as FPT from '../../utility/fpt';
import  ExtendSession  from '../../ppgf/components/ExtendSession';
import withTheme from '../../common/withTheme';

const EditSecondaryContact = (props) => {
    const messages = parseMessages('givingfund').profile;
    const pageDetails = JSON.parse(document.getElementById('data-page-details') && document.getElementById('data-page-details').innerHTML || '{}');
    const [firstName, setFirstName] = useState({ name: 'firstName', value: get(props.charityInfo, 'secondaryContact.first_name', '') });
    const [lastName, setLastName] = useState({ name: 'lastName', value: get(props.charityInfo, 'secondaryContact.last_name', '') });
    const [title, setTitle] = useState({ name: 'title', value: get(props.charityInfo, 'secondaryContact.job_title', '') });
    const [phone, setPhone] = useState({ name: 'phone', value: get(props.charityInfo, 'secondaryContact.phone_number', '') });
    const [email, setEmail] = useState({ name: 'email', value: get(props.charityInfo, 'secondaryContact.email_address', '') });
    const [cancelModal, setCancelModal] = useState(false);

    const onBlurTextInput = (e, setValue) => {
        let errorText = ''
        if (e.target.name === 'email') {
            errorText = !validateEmail(e.target.value) && messages.email.error.invalid;
        } else {
            errorText = !e.target.value && messages.field.error.required;
        }
        setValue({ name: e.target.name, value: e.target.value, errorText: errorText });
    }
    const validateForm = () => {
        let errorFields = [];
        props.validateField(firstName, errorFields, setFirstName);
        props.validateField(lastName, errorFields, setLastName);
        props.validateField(title, errorFields, setTitle);
        if (!phone.value || phone.errorText) {
            errorFields.push('phoneInput-phone');
            setPhone({ name: 'phone', value: phone.value, errorText: messages.phone.error.invalid });
        }
        if (!email.value || email.errorText) {
            errorFields.push('email');
            setEmail({ name: 'email', errorText: messages.email.error.invalid });
        }
        return errorFields;
    }

    const onFormSubmit = () => {
        const errorFields = validateForm();
        if (errorFields.length > 0) {
            FPT.trackButtonClick('contactFormSubmitErr');
            document.getElementsByName(errorFields[0])[0].focus();
        } else {
            const payload = {
                secondarContact: JSON.stringify([{
                    email_address: email.value,
                    role: 'FUND_RAISER',
                    first_name: firstName.value,
                    last_name: lastName.value,
                    job_title: title.value,
                    phone_number: phone.value
                }])
            };
            FPT.trackButtonClick('ContactEditSubmitBtn');
            props.onSubmitProfileForm(payload);
        }
    }

    const handleQuitModal = (open) => {
        open && FPT.trackButtonClick('QuitContactModal');
        setCancelModal(open);
    }

    const handlePhoneSelection = (phoneNo) => {
        let errorText;
        if (phoneNo.length != get(pageDetails, 'phoneConfig.nationalNumber', '').length) {
            errorText = messages.phone.error.invalid
        }
        setPhone({ name: 'phone', value: phoneNo, errorText });
    }

    useEffect(() => {
        FPT.trackPage('main:givingfund:editSecondaryContact');
    }, [])

    return (<>
        <ExtendSession scaCountry={pageDetails.scaCountry} basePage="editSecContact" />
        <Dialog isOpen={cancelModal} hideTitle={true} closeButtonLabel={messages.cancel} center={true} onClose={() => handleQuitModal(false)}>
            <div style={{ marginBottom: '2rem' }}>
                <img src="https://www.paypalobjects.com/paypal-ui/illustrations/focused/svg/empty-warning.svg" width="72px" height="72px" alt={messages.update.closeModal.head} />
            </div>
            <HeadingText style={{ marginBottom: '2rem' }} size="sm">{messages.secondaryContact.closeModal.head}</HeadingText>
            <div>
                <Button onClick={() => handleQuitModal(false)}>{messages.secondaryContact.closeModal.finishBtn}</Button>
            </div>
            <div>
                <Button style={{ marginBottom: '4rem' }} tertiary onClick={() => { props.setProfileEditView('', 'quitContactFormBtn') }}>{messages.update.closeModal.quitBtn}</Button>
            </div>
        </Dialog>
        <HeadingText size="lg" className="editProfileHead">{messages.secondaryContact.head}</HeadingText>
        <Container className="profile" form>
            {props.charityInfo.error &&
                <Row className="serviceError">
                    <Col md={{ span: 8, offset: 2 }}>
                        <Alert type="error">{messages.serviceError}</Alert>
                    </Col>
                </Row>}
            <Row style={{ marginBottom: '2rem' }}>
                <Col md={{ span: 8, offset: 2 }}>
                    <TextDisplay
                        name="contactInfo"
                        value={messages.secondaryContact.description}
                    />
                </Col>
            </Row>
            <Row className="txtInput">
                <Col md={{ span: 8, offset: 2 }}>
                    <TextInput
                        label={messages.firstName.label}
                        onBlur={(e) => onBlurTextInput(e, setFirstName)}
                        onChange={(e) => onBlurTextInput(e, setFirstName)}
                        {...firstName}
                    />
                </Col>
            </Row>
            <Row className="txtInput">
                <Col md={{ span: 8, offset: 2 }}>
                    <TextInput
                        label={messages.lastName.label}
                        onBlur={(e) => onBlurTextInput(e, setLastName)}
                        onChange={(e) => onBlurTextInput(e, setLastName)}
                        {...lastName}
                    />
                </Col>
            </Row>
            <Row className="txtInput">
                <Col md={{ span: 8, offset: 2 }}>
                    <TextInput
                        label={messages.title.label}
                        onBlur={(e) => onBlurTextInput(e, setTitle)}
                        onChange={(e) => onBlurTextInput(e, setTitle)}
                        {...title}
                    />
                </Col>
            </Row>
            <Row className="txtInput">
                <Col md={{ span: 8, offset: 2 }}>
                    <PhoneInput
                        {...phone}
                        countryOptions={pageDetails.phoneConfig}
                        onAccept={(number, unmasked) => handlePhoneSelection(unmasked)}
                    />
                </Col>
            </Row>
            <Row className="txtInput">
                <Col md={{ span: 8, offset: 2 }}>
                    <TextInput
                        label={messages.email.label}
                        onBlur={(e) => onBlurTextInput(e, setEmail)}
                        onChange={(e) => onBlurTextInput(e, setEmail)}
                        {...email}
                    />
                </Col>
            </Row>
            <Row>
                <Col style={{ textAlign: 'center' }}>
                    <Button onClick={onFormSubmit} className="submitBtn">{messages.save}</Button>
                </Col>
            </Row>
            <Row>
                <Col style={{ textAlign: 'center' }}>
                    <Button tertiary onClick={() => handleQuitModal(true)}>{messages.cancel}</Button>
                </Col>
            </Row>
        </Container>
    </>)
}

export default withTheme(EditSecondaryContact);